<template>
  <div class="order-wrap">

    <div class="order-list-wrap">
      <div class="order-card">
        <div class="order-tab">
          <div class="tabs">
            <div @click="changeTab(null)" :class="['item', { 'active': listQuery.team_status === null }]">全部订单<span
                class="num">{{
              statusall || 0 }}</span></div>
            <div @click="changeTab('0')" :class="['item', { 'active': listQuery.team_status === '0' }]">待审批<span
                class="num">{{
              status0
              || 0 }}</span></div>
            <div @click="changeTab('1')" :class="['item', { 'active': listQuery.team_status === '1' }]">已审批<span
                class="num">{{
              status1
              || 0 }}</span></div>
            <div @click="changeTab('2')" :class="['item', { 'active': listQuery.team_status === '2' }]">已驳回<span
                class="num">{{
              status2
              || 0 }}</span></div>
          </div>
        </div>
        <div class="order-content-wrap">
          <div class="search-bar">
            <div class="search-inp-wrap">
              <el-input placeholder="请输入关键词" style="width: 300px;" v-model="listQuery.keyword" clearable
                @clear="handleFilter" @keyup.enter.native="handleFilter">
                <el-button slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
              </el-input>
            </div>
            <!-- <div class="page-operate">
              <div class="page-btn" @click="handlePrevPage()">上一页</div>
              <div class="page-btn" @click="handleNextPage()">下一页</div>
            </div> -->
          </div>

          <div class="table-wrap">
            <div class="flex-row">
              <el-button size="mini" :disabled="checkList.length == 0" @click="handleMultiAgree"
                class="my-btn">批量通过</el-button>
              <el-button size="mini" :disabled="checkList.length == 0" @click="handleMultiReject"
                class="my-btn">批量驳回</el-button>
            </div>

            <el-table class="xm-table" :data="list" v-loading="loading" element-loading-text="给我一点时间"
              :empty-text="emptyText" fit highlight-current-row>
              <el-table-column label="订单信息" align="center" minWidth="400">
                <template slot="header" slot-scope="scope">
                  <div class="flex-row">
                    <div class="flex-grow-0 mgl10">
                      <el-checkbox v-model="checkAll" @change="handleCheckAll">全选</el-checkbox>
                    </div>
                    <div class="flex-grow-1">订单信息</div>
                  </div>
                </template>
                <template slot-scope="{row}">
                  <div class="row01 flex-row">
                    <div class="flex-grow-0 mgl10">
                      <el-checkbox v-model="row.checked" :disabled="row.status != 90" @change="handleCheck(row)">
                      </el-checkbox>
                    </div>
                    <span class="flex-grow-1 mgl10 tal">订单号：{{ row.order_no }} </span>
                    <span class="flex-grow-0">时间：{{ row.create_time }}</span>
                  </div>
                  <div class="row002" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <div class="flex-col goods" v-for="(product, index) in row.product" :key="index">
                      <div class="flex-row mgt10 mgl10 tal">
                        <div class="flex-grow-0 mgr10">
                          <el-image style="width: 70px;height: 70px;" :src="product.cover"></el-image>
                        </div>
                        <div class="flex-grow-1 flex-col">
                          <div class="name">
                            <span>{{ product.name }}</span>
                          </div>
                          <div class="desc">
                            <span>×{{ product.num }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="金额" align="center" width="120">

                <template slot-scope="{row}">
                  <div class="row01">
                  </div>
                  <div class="row02 flex-xy-center flex-col"
                    :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <span>￥{{ row.pay_amount }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center" width="100">

                <template slot-scope="{row}">
                  <div class="row01">
                  </div>
                  <div class="row02 flex-xy-center" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <span>{{ row.status_name }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center" width="120">

                <template slot-scope="{row}">
                  <div class="row01">
                  </div>
                  <div class="row02 flex-xy-center flex-col"
                    :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <span>{{ row.remark }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100" fixed="right">

                <template slot-scope="{row}">
                  <div class="row01">
                  </div>
                  <div class="row02 flex-xy-center flex-col"
                    :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <template v-if="row.status == 90">
                      <el-link class="colorBlue" :underline="false" @click="handleSetAgree(row)">审批通过</el-link>
                      <el-link class="colorRed" :underline="false" @click="handleSetReject(row)">审批驳回</el-link>
                    </template>
                    <el-link :underline="false" @click="handleDetail(row)">查看详情</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="flex-row mgt20">
            <div class="flex-grow-1"></div>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderList, setOrderAgree, setOrderReject } from "@/api/team";
import waves from '@/directive/waves' // 水波纹指令
import clipboard from '@/directive/clipboard' // 复制指令

export default {
  name: "StoreOrderList",
  components: {

  },
  directives: {
    waves,
    clipboard
  },
  props: {},
  data() {
    return {
      loading: false,
      status: 0,
      emptyText: '暂无数据',
      listQuery: {
        team_status: null,
        keyword: null,
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
      statusall: 0,
      status0: 0,
      status1: 0,
      status2: 0,
      tableRowHeight: 90,
      checkList: [],
      checkAll: false,
    }

  },
  watch: {},
  created() {
    this.getList();
  },
  mounted() {
    this.formatPrice = this.utils.formatPrice;
    this.parseTime = this.utils.parseTime;
  },
  methods: {
    handleCheckAll(val) {
      // console.log(val)
      this.list.forEach((item) => {
        if (!item.disabled) {
          item.checked = val;
        }
      });
      this.handleCheck();
    },
    handleCheck() {
      this.checkList = this.list.filter((item) => {
        return item.checked;
      }).map((item) => {
        return item.id;
      });
      // console.log(this.checkList)
      if (this.checkList.length == this.list.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    changeTab(status) {
      this.listQuery.team_status = status
      this.getList()
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getOrderList(_listQuery)
        .then((response) => {
          this.list = response.data.list.map((item, index) => {
            item.checked = false;
            item.disabled = item.status == 90 ? false : true;
            return item;
          });
          this.total = response.data.count * 1;
          this.statusall = response.data.statusall * 1;
          this.status0 = response.data.status0 * 1;
          this.status1 = response.data.status1 * 1;
          this.status2 = response.data.status2 * 1;
          this.loading = false;
          this.checkAll = false;
          this.checkList = [];
        }).catch(() => {
          this.loading = false;
        });
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    // 上一页
    handlePrevPage() {
      let page = this.listQuery.page;
      if (page - 1 > 1) {
        page--
      }
      this.listQuery.page = page;
      this.getList();
    },
    // 下一页
    handleNextPage() {
      let page = this.listQuery.page;
      if ((this.total / this.listQuery.pagesize) > page + 1) {
        page++
      }
      this.listQuery.page = page;
      this.getList();
    },
    clipboardSuccess() {
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    // 审批通过
    handleSetAgree(order) {
      this.checkList.push(order.id);
      this.handleMultiAgree()
    },
    // 审批驳回
    handleSetReject(order) {
      this.checkList.push(order.id);
      this.handleMultiReject()
    },
    //批量通过
    handleMultiAgree() {
      if (this.checkList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择订单'
        });
        return false;
      }
      this.$confirm('确定要审核通过订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        setOrderAgree({
          ids: this.checkList.join(',')
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message.success('操作成功!');
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    //批量驳回
    handleMultiReject() {
      if (this.checkList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择订单'
        });
        return false;
      }
      this.$confirm('确定要驳回此订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        setOrderReject({
          ids: this.checkList.join(',')
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message.success('操作成功!');
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    // 查看详情
    handleDetail(order) {
      this.$router.push({
        path: '/team/order/detail',
        query: {
          id: order.id
        }
      });
    },
  }
};
</script>

<style lang='scss' scoped>
.order-wrap {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;

  .table-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    // align-items: center;
    padding: 10px 0 0 0;

    .table {
      border: 1px solid #DCE5EB;
    }

    th {
      text-align: center;
      padding: 13px 0;
    }

    thead {
      tr {
        th {
          background-color: #E9F3F6;
        }

        th:nth-child(1) {
          font-size: 16px;
          font-weight: 400;
          color: #222222;

          i {
            color: #6F7F84;
          }
        }

        th:nth-child(2),
        th:nth-child(3),
        th:nth-child(4) {
          width: 120px;
        }

        th:nth-child(5) {
          width: 170px;
        }
      }
    }

    tbody {
      .name-th {
        width: 100%;
        display: flex;
        align-items: center;
        column-gap: 10px;
        padding-left: 30px;
        box-sizing: border-box;

        &>img {
          width: 75px;
          height: 75px;
        }
      }

      .pay-btn {
        width: 90px;
        height: 30px;
        background: #00B4E8;
        border-radius: 15px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 auto;
      }

      .download-btn {
        width: 90px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 15px;
        font-size: 16px;
        font-weight: 400;
        color: #00B4E8;
        margin: 0 auto;
        border: solid 1px #00B4E8;
      }

      tr {
        th {
          p {
            margin: 5px 0;
            cursor: pointer;
          }
        }
      }

      th:not(:last-child) {
        border-right: 1px solid #DCE5EB;
      }

      tr:not(:last-child) {
        border-bottom: 1px solid #DCE5EB;
      }

      &>.empty {
        position: relative;
        height: 43px;

        &>th {
          position: absolute;
          width: 100%;
          height: 43px;
          font-size: 15px;
          color: #999999;
        }
      }
    }
  }


  .order-list-wrap {
    width: 100%;

    .order-card {
      width: 100%;
      margin-top: 16px;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
      border-radius: 2px;
      padding-bottom: 20px;

      .order-tab {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #CCD7DB;
        padding: 19px 25px 0 25px;
        box-sizing: border-box;

        .tabs {
          display: flex;
          align-items: center;
          column-gap: 60px;
          width: 100%;

          .item {
            font-size: 16px;
            font-weight: 400;
            color: #222222;
            padding-bottom: 11px;
            cursor: pointer;

            .num {
              color: #00B4E8 !important;
              margin-left: 5px;
            }
          }

          .active {
            color: #00B4E8 !important;
            border-bottom: 2px solid #00B4E8 !important;
          }
        }

        .order-manager {
          width: 70px;
          font-size: 16px;
          font-weight: 400;
          color: #222222;
          padding-bottom: 11px;
          cursor: pointer;
        }

        .order-manager-active {
          color: #00B4E8 !important;
          border-bottom: 2px solid #00B4E8 !important;
        }
      }

      .order-content-wrap {
        width: 100%;
        box-sizing: border-box;
        padding: 0 27px;

        .data-type-wrap {
          display: flex;
          align-items: center;
          column-gap: 20px;
          margin-top: 20px;

          .active {
            color: #FFFFFF !important;
            background: #00B4E8 !important;
          }

          .item {
            font-size: 16px;
            font-weight: 400;
            color: #00B4E8;
            background: #00b6e81a;
            padding: 7px 41px;
            cursor: pointer;
          }
        }

        .empty-tip {
          display: block;
          margin: 0 auto;
        }

        .search-bar {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px 0;

          .search-inp-wrap {
            box-shadow: 0px 12px 19px 1px rgba(60, 128, 209, 0.0863);
            display: flex;
            align-items: center;

            .inp-wrap {
              width: 367px;
              height: 40px;
              padding: 0 22px;
              display: flex;
              align-items: center;

              &>input {
                width: 100%;
                border: none;
                outline: none;
                background-color: transparent;
              }
            }

            .search-btn {
              width: 65px;
              height: 40px;
              background: #6F7F84;
              box-shadow: 0px 12px 19px 1px rgba(60, 128, 209, 0.0863);
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .page-operate {
            display: flex;
            align-items: center;
            column-gap: 5px;

            .page-btn {
              padding: 8px 16px;
              font-size: 16px;
              font-weight: 400;
              color: #CCD7DB;
              width: 82px;
              background: #FFFFFF;
              border-radius: 2px;
              border: 1px solid #CCD7DB;
            }
          }
        }

        .table-header {
          width: 100%;
          padding: 7px 0;
          background: rgba(111, 127, 132, 0.102);
          display: grid;
          grid-template-columns: auto 120px 120px 120px 170px;
          font-size: 16px;
          font-weight: 400;
          color: #6F7F84;
          align-items: center;
          text-align: center;
          box-sizing: border-box;
        }
      }
    }
  }

}
</style>
